// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__oN1BL","dragIcon":"Choice_dragIcon__u5wKb","left":"Choice_left__1atZb","input":"Choice_input__qPZuJ"};